<script>
import router from '@/router';
import axios from 'axios';
import Header from '@/components/front/Header';
import Footer from '@/components/front/Footer';

export default {
	page: {
		title: 'Volunteer System',
		meta: [
			{
				name: 'Volunteer System',
			},
		],
	},
	props: ['userType', 'location'],
	components: { Header, Footer },
	data() {
		return {
			title: '',
			items: [
				{
					text: '',
					href: '/',
				},
			],
			roles: [],
			selectedRole: [],
			locationID: 0,
			userData: JSON.parse(localStorage.getItem('web_user')),
		};
	},
	mounted() {
		if (this.userData) {
			this.locationID = this.userData.location_id;
		}
		this.getRoles();
	},
	methods: {
		createAccount() {
			let selectedRoleArr = [];
			this.selectedRole.map(function (value) {
				selectedRoleArr.push(value.id);
			});
			localStorage.setItem('selectedRoles', JSON.stringify(selectedRoleArr));
			router.push({ name: 'create-account' });
		},
		checkSelected(index) {
			let role = this.roles[index];
			role.active = !role.active;
			this.$set(this.roles, index, role);
			if (role.active) {
				this.selectedRole.push(role);
			} else {
				const filtersRole = this.selectedRole.filter((element) => element !== role);
				this.selectedRole = filtersRole;
			}
		},

		getRoles() {
			// axios.get('roles?type=active').then(res =>{
			//   this.roles = res.data.response;
			//   // console.log(this.roles);
			// })
			axios.get('roles_by_location/' + this.locationID).then((res) => {
				this.roles = res.data.response;
				this.roles.forEach((role, index) => {
					try {
						this.roles[index].time_slots = JSON.parse(role.time_slots);
					} catch (err) {
						this.roles[index].time_slots = {
							monday: {
								is_checked: false,
								time: '',
							},
							tuesday: {
								is_checked: false,
								time: '',
							},
							wednesday: {
								is_checked: false,
								time: '',
							},
							thursday: {
								is_checked: false,
								time: '',
							},
							friday: {
								is_checked: false,
								time: '',
							},
							saturday: {
								is_checked: false,
								time: '',
							},
						};
					}
				});
				// console.log(this.roles);
			});
		},
	},
};
</script>

<template>
	<div>
		<Header></Header>
		<section class="main-body">
			<div id="main-title">
				<div class="container">
					<div class="row">
						<div class="col">
							<h3 class="title">Become A Volunteer</h3>
						</div>
					</div>
				</div>
			</div>
			<div class="main-section">
				<div class="container">
					<div class="row">
						<div class="col-12 col-lg-6">
							<div class="account-box text-center text-lg-start mb-5 mb-md-0">
								<p>If you do not see a role that is of interest to you, please submit your application for future consideration.</p>
								<b-button @click="createAccount" variant="custom">Create Account to Begin Application</b-button>
							</div>
						</div>
						<div class="col-12 col-lg-6">
							<!-- <div class="opportunity-box text-center text-lg-start">
              <h3 class="title">Looking for Group Volunteer Opportunities?</h3>
              <p>In Minneapolis, apply online:<a href="https://www.mntc.org/volunteer/groupvolunteer/" class="apply"> https://www.mntc.org/volunteer/groupvolunteer/ </a><br> For any of our other campuses where you would like to volunteer as a group, there is no need to apply online. Please contact the appropriate Volunteer Coordinator at your nearest center.<br> Lakeside Academy (Teen Boys Center, Buffalo) &nbsp; 612.238.6777  &nbsp; <a href="#">More Info (PDF)</a></p>
              </div> -->
							<img src="@/assets/images/group-volunteer-opportunities.jpg" alt="Looking for Group Volunteer Opportunities" />
						</div>
					</div>
				</div>
				<div class="roles-container">
					<div class="container">
						<div class="row">
							<div class="col d-flex justify-content-center position-relative">
								<h3 class="title text-center">Please click on all of the roles that you are interested in</h3>
							</div>
						</div>
						<div class="roles-list">
							<div class="row">
								<div class="col-12 col-md-6 col-lg-6 col-xl-4 mb-4" v-for="(role, index) in roles" :key="index" :class="{ selected: role.active }" :id="index" @click="checkSelected(index)">
									<div class="card">
										<div class="card-body">
											<h5 class="card-title">{{ role.name }}</h5>
											<h6 class="card-subtitle text-muted">{{ role.location ? role.location.name : '' }}</h6>
											<p class="card-text">{{ role.description }}</p>
											<div class="special" v-if="role.special_requirement">
												<h3 class="heading">SPECIAL REQUIREMENTS:</h3>
												<p>{{ role.special_requirement }}</p>
											</div>
											<p class="mt-3">
												<span v-if="role?.time_slots?.monday?.is_checked">Monday : {{ role?.time_slots?.monday?.time }}, <br /> </span>
												<span v-if="role?.time_slots?.tuesday?.is_checked">Tuesday : {{ role?.time_slots?.tuesday?.time }},<br /></span>
												<span v-if="role?.time_slots?.wednesday?.is_checked">Wednesday : {{ role?.time_slots?.wednesday?.time }},<br /></span>
												<span v-if="role?.time_slots?.thursday?.is_checked">Thursday : {{ role?.time_slots?.thursday?.time }},<br /></span>
												<span v-if="role?.time_slots?.friday?.is_checked">Friday : {{ role?.time_slots?.friday?.time }},<br /></span>
												<span v-if="role?.time_slots?.saturday?.is_checked">Saturday: {{ role?.time_slots?.saturday?.time }},<br /></span>
												<span v-if="role?.time_slots?.sunday?.is_checked">Sunday: {{ role?.time_slots?.sunday?.time }},<br /></span>
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col text-center">
								<b-button @click="createAccount" variant="custom">Create Account to Begin Application</b-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<Footer></Footer>
	</div>
</template>
